import React from 'react'
import { Row, Col } from 'antd'
import Camera from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import CameraClose from './CameraClose'

const CameraArea = props => {    
    const { camera,microphone } = props
    navigator.mediaDevices.getUserMedia({ audio: microphone })
    .then(function(stream) {
    //   console.log(stream)
    })
    .catch(function(err) {
        // console.log(err)
    });
    
    return (
        <Row>    
            <Col span={24}>
            {camera ? (
                <Camera
                    isFullscreen={true}
                    isMaxResolution={true}
                />
              ) : (
                <CameraClose />
                )
            }

            </Col>
        </Row>
    )
}

export default CameraArea